import { Outlet } from "react-router-dom";
import { PricingProfileContextProvider } from "./PricingProfileContext";

export const PricingProfileRoute = () => (
  <PricingProfileContextProvider>
    <Outlet />
  </PricingProfileContextProvider>
);
